import { TopologyPrefixName } from '~/interfaces/operator.interface';

export const topologyPrefixConstant : Record<string, TopologyPrefixName[]> = {
    "netatmo" : [{
            "text" : "netatmo / H+C",
            "prefix" : "",
    }],
    "eliot" : [{
        "text" : "eliot",
        "prefix" : "legrand://"
    }],
    "vaillant" : [
        {
            "text" : "vaillant",
            "prefix" : "vaillant://"
        },
        {
            "text" : "sdbg",
            "prefix" : "sdbg://"
        }
    ],
    "muller" : [{
        "text" : "muller",
        "prefix" : "muller://"
    }],
    "velux" : [{
        "text" : "velux",
        "prefix" : "velux://"
    }]
}
